"use client";

import React, { createContext, useContext } from "react";
import { useIndicatorState } from "@/hooks/useIndicatorState";
import { useIndicatorCatalog } from "@/hooks/useIndicatorCatalog";

type IndicatorsContextValue = ReturnType<typeof useIndicatorState> &
  ReturnType<typeof useIndicatorCatalog>;

const IndicatorsContext = createContext<IndicatorsContextValue | undefined>(
  undefined
);

export function IndicatorsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const indicatorState = useIndicatorState();
  const indicatorCatalog = useIndicatorCatalog();

  return (
    <IndicatorsContext.Provider
      value={{ ...indicatorState, ...indicatorCatalog }}
    >
      {children}
    </IndicatorsContext.Provider>
  );
}

export function useIndicators() {
  const ctx = useContext(IndicatorsContext);
  if (!ctx) {
    throw new Error("useIndicators must be used within IndicatorsProvider");
  }
  return ctx;
}
